
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Clock, Flame } from "lucide-react";
import { VideoItem } from "@/types/video";

interface VideoCardProps {
  video: VideoItem;
  userCredits: number;
  onViewVideo: (videoId: number, videoCredits: number) => void;
}

export function VideoCard({ video, userCredits, onViewVideo }: VideoCardProps) {
  return (
    <Card key={video.id} className="relative overflow-hidden">
      {video.isPremiere && (
        <Badge variant="destructive" className="absolute top-2 right-2 flex items-center z-10">
          <Flame className="h-3 w-3 mr-1" /> ΠΡΕΜΙΕΡΑ
        </Badge>
      )}
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{video.title}</CardTitle>
        <CardDescription className="flex items-center">
          <Clock className="h-3 w-3 mr-1" /> Διάρκεια: {video.duration}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mb-4 overflow-hidden rounded-md">
          <AspectRatio ratio={16/9}>
            <img 
              src={video.thumbnailUrl || "/placeholder.svg"} 
              alt={`Προεπισκόπηση: ${video.title}`}
              className="w-full h-full object-cover transition-transform hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
              <div className="w-12 h-12 rounded-full bg-primary/80 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
              </div>
            </div>
          </AspectRatio>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-primary flex items-center">
            <span className="inline-block px-2 py-1 bg-primary/10 rounded-md text-primary font-medium mr-1">
              {video.credits}
            </span> 
            Credits
          </span>
          <Button 
            size="sm"
            onClick={() => onViewVideo(video.id, video.credits)}
            disabled={userCredits < video.credits}
          >
            {userCredits >= video.credits ? 'Προβολή' : 'Ανεπαρκή Credits'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
